"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TableCell", {
    enumerable: true,
    get: function() {
        return TableCell;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTableCell = require("./useTableCell");
const _renderTableCell = require("./renderTableCell");
const _useTableCellStylesstyles = require("./useTableCellStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TableCell = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTableCell.useTableCell_unstable)(props, ref);
    (0, _useTableCellStylesstyles.useTableCellStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTableCellStyles_unstable')(state);
    return (0, _renderTableCell.renderTableCell_unstable)(state);
});
TableCell.displayName = 'TableCell';
